import { render, staticRenderFns } from "./indexHotIndustry.vue?vue&type=template&id=e6c9f58e&scoped=true&"
import script from "./indexHotIndustry.vue?vue&type=script&lang=js&"
export * from "./indexHotIndustry.vue?vue&type=script&lang=js&"
import style0 from "./indexHotIndustry.vue?vue&type=style&index=0&id=e6c9f58e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c9f58e",
  null
  
)

export default component.exports